"use client"

import { useEffect, useRef } from 'react'

function CheckboxGuard ({ children, onlyOne }) {
    const ref = useRef()

    useEffect(() => {
        const wrap = ref.current

        const clear = (inputs) => {
            [...inputs].forEach(input => input.checked = false)
        }

        const click = (event) => {
            const { target } = event
            if (target?.nodeName !== 'INPUT') return
            const { name } = target
            if (onlyOne || name.endsWith('wszystkie')) {
                clear(wrap.querySelectorAll(`[type="checkbox"]:not([name="${name}"])`))
            } else {
                clear(wrap.querySelectorAll(`[type="checkbox"][name$="wszystkie"]`))
            }
        }

        wrap.addEventListener('click', click)

        return () => wrap.removeEventListener('click', click)
    }, [onlyOne])

    return (
        <div ref={ref}>{children}</div>
    )
}

export {
    CheckboxGuard,
}